
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { safehtmlpipe } from './pipes/htmlpipe/safehtmlpipe';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { CmLocationsComponent } from './UI/cm-locations/cm-locations.component';
import { CmDashboardComponent } from './UI/cm-dashboard/cm-dashboard.component';
import { RptBcmDashboardComponent } from './UI/rpt-bcm-dashboard/rpt-bcm-dashboard.component';
import { CmGeneralComponent } from './UI/cm-general/cm-general.component';
import { CmPaymentComponent } from './UI/cm-payment/cm-payment.component';
import { LeftSideMenuComponent } from './UI/left-side-menu/left-side-menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenusModule } from '@progress/kendo-angular-menu';
import { DropDownListModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconsModule } from '@progress/kendo-angular-icons';
import { CommonModule, DatePipe } from '@angular/common';
import { EmailService } from './services/shared/email.service';
import { GlobalService } from './services/shared/global.service';
import { LocalService } from './services/shared/local.service';
import { LocalService as engagelocal } from './services/contact-services/shared/local.service';
import { MenuService } from './services/shared/menu.service';
import { UtilityService } from './services/shared/utility.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { MatSelectModule } from '@angular/material/select';
import { EditorModule } from '@progress/kendo-angular-editor';
import { MissingCredentialsComponent } from './UI/missing-credentials/missing-credentials.component';
import { SiteFieldsComponent } from './UI/site-fields/site-fields.component';
import { LocationLeftMenuComponent } from './UI/location-manager/location-left-menu/location-left-menu.component';
import { LmTriggersComponent } from './UI/location-manager/lm-triggers/lm-triggers.component';
import { LmLinksComponent } from './UI/location-manager/lm-links/lm-links.component';
import { LmMarketingComponent } from './UI/location-manager/lm-marketing/lm-marketing.component';
import { LmDiscountsComponent } from './UI/location-manager/lm-discounts/lm-discounts.component';
import { LmEmployeesComponent } from './UI/location-manager/lm-employees/lm-employees.component';
import { LmContractListComponent } from './UI/location-manager/lm-contract-list/lm-contract-list.component';
import { LmContractSettingsComponent } from './UI/location-manager/lm-contract-settings/lm-contract-settings.component';
import { LmEngageDashComponent } from './UI/location-manager/lm-engage-dash/lm-engage-dash.component';
import { LmVesselsComponent } from './UI/location-manager/lm-vessels/lm-vessels.component';
import { LmGeneralComponent } from './UI/location-manager/lm-general/lm-general.component';
import { LmProductsComponent } from './UI/location-manager/lm-products/lm-products.component';
import { LmDashboardComponent } from './UI/location-manager/lm-dashboard/lm-dashboard.component';
import { LmPaymentComponent } from './UI/location-manager/lm-payment/lm-payment.component';
import { CmContractComponent } from './UI/cm-contract/cm-contract.component';
import { CmContractClientComponent } from './UI/cm-contract-client/cm-contract-client.component';
import { CmContractMappingComponent } from './UI/cm-contract-mapping/cm-contract-mapping.component';
import { NotificationService } from './services/notification.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CmEmployeesComponent } from './UI/cm-employees/cm-employees.component';
import { CmContractListComponent } from './UI/cm-contract-list/cm-contract-list.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { CurrencyDirective } from './pipes/currency.directive';
import { AcceptCharacterDirective } from './pipes/acceptcharacter.directive';
import { PercentageDirective } from './pipes/two-digit-decima-number.directive';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { CmContractLogComponent } from './UI/cm-contract-log/cm-contract-log.component';
import { CmActivityLogComponent } from './UI/cm-activity-log/cm-activity-log.component';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { PhoneFormatPipe } from './pipes/phone-format.pipe';
import { NgxEditorModule } from 'ngx-editor';
import { MemDashboardComponent } from './UI/mem-module/mem-dashboard/mem-dashboard.component';
import { MembershipComponent } from './UI/mem-module/membership/membership.component';
import { MemContactComponent } from './UI/mem-module/mem-contact/mem-contact.component';
import { MemPauseComponent } from './UI/mem-module/mem-pause/mem-pause.component';
import { MemInsuranceDeductibleComponent } from './UI/mem-module/mem-insurance-deductible/mem-insurance-deductible.component';
import { MemPolicyViolationComponent } from './UI/mem-module/mem-policy-violation/mem-policy-violation.component';
import { MemCaseComponent } from './UI/mem-module/mem-case/mem-case.component';
import { MemSubscriptionComponent } from './UI/mem-module/mem-subscription/mem-subscription.component';
import { MemLeftSideMenuComponent } from './UI/mem-module/mem-left-side-menu/mem-left-side-menu.component';
import { MemInsuranceDeductibleListComponent } from './UI/mem-module/mem-insurance-deductible-list/mem-insurance-deductible-list.component';
import { MemPolicyViolationListComponent } from './UI/mem-module/mem-policy-violation-list/mem-policy-violation-list.component';
import { MemSubscriptionListComponent } from './UI/mem-module/mem-subscription-list/mem-subscription-list.component';
import { MemCaseListComponent } from './UI/mem-module/mem-case-list/mem-case-list.component';
import { MemPauseListComponent } from './UI/mem-module/mem-pause-list/mem-pause-list.component';
import { MemContactListComponent } from './UI/mem-module/mem-contact-list/mem-contact-list.component';
import { MembershipListComponent } from './UI/mem-module/membership-list/membership-list.component';
import { MemContactDetailsComponent } from './UI/mem-module/mem-contact-details/mem-contact-details.component';
import { BulkContactActionsComponent } from './UI/mem-module/bulk-contact-actions/bulk-contact-actions.component';
import { ClassLookupComponent } from './UI/mem-module/class-lookup/class-lookup.component';
import { ContactComponent } from './UI/mem-module/contact/contact.component';
import { ContactActivityHistoryComponent } from './UI/mem-module/common/contact-activity-history/contact-activity-history.component';
import { ContactListComponent } from './UI/mem-module/contactList/contactList.component';
import { ContactUploadExcelComponent } from './UI/mem-module/contact-upload-excel/contact-upload-excel.component';
import { ImportHistoryComponent } from './UI/mem-module/import-history/import-history.component';
import { LeadApptComponent } from './UI/mem-module/lead-module/common/lead-appt/lead-appt.component';
import { QuickLinkComponent } from './UI/mem-module/lead-module/common/quick-link/quick-link.component';
import { LeadEmailComponent } from './UI/mem-module/lead-module/common/lead-email/lead-email.component';
import { LinkComponent } from './UI/mem-module/link/link.component';
import { ManageCampaignsComponent } from './UI/mem-module/manage-campaigns/manage-campaigns.component';
import { EngageMetricComponent } from './UI/mem-module/engage-metric/engage-metric.component';
import { ManageDuplicateComponent } from './UI/mem-module/manage-duplicate/manage-duplicate.component';
import { AppointmentCommonComponent } from './UI/mem-module/common/appointment-common/appointment-common.component';
import { BulkContactCommonComponent } from './UI/mem-module/common/bulk-contact-common/bulk-contact-common.component';
import { ContactArchiveComponent } from './UI/mem-module/common/contact-archive/contact-archive.component';
import { ContactCallComponent } from './UI/mem-module/common/contact-call/contact-call.component';
import { ContactCommonSearchComponent } from './UI/mem-module/common/contact-common-search/contact-common-search.component';
import { ContactDuplicateComponent } from './UI/mem-module/common/contact-duplicate/contact-duplicate.component';
import { ContactEmailComponent } from './UI/mem-module/common/contact-email/contact-email.component';
import { ContactExportsComponent } from './UI/mem-module/common/contact-exports/contact-exports.component';
import { ContactHistoryNoteComponent } from './UI/mem-module/common/contact-history-note/contact-history-note.component';
import { ContactMapCommonComponent } from './UI/mem-module/common/contact-map-common/contact-map-common.component';
import { ContactMapComponent } from './UI/mem-module/common/contact-map/contact-map.component';
import { ContactMeetingComponent } from './UI/mem-module/common/contact-meeting/contact-meeting.component';
import { ContactNewCallComponent } from './UI/mem-module/common/contact-new-call/contact-new-call.component';
import { ContactNoteComponent } from './UI/mem-module/common/contact-note/contact-note.component';
import { ContactRecentLeadComponent } from './UI/mem-module/common/contact-recent-lead/contact-recent-lead.component';
import { ContactRecentMailingComponent } from './UI/mem-module/common/contact-recent-mailing/contact-recent-mailing.component';
import { ContactReferredComponent } from './UI/mem-module/common/contact-referred/contact-referred.component';
import { ContactSearchComponent } from './UI/mem-module/common/contact-search/contact-search.component';
import { ContactSettingsComponent } from './UI/mem-module/common/contact-settings/contact-settings.component';
import { ContactSmsComponent } from './UI/mem-module/common/contact-sms/contact-sms.component';
import { ContactTaskComponent } from './UI/mem-module/common/contact-task/contact-task.component';
import { EmailOptLogComponent } from './UI/mem-module/common/email-opt-log/email-opt-log.component';
import { QuickRecentListComponent } from './UI/mem-module/common/home-module/common/quick-recent-list/quick-recent-list.component';
import { MobileOptLogComponent } from './UI/mem-module/common/mobile-opt-log/mobile-opt-log.component';
import { MyCalenderComponent } from './UI/mem-module/common/my-calender/my-calender.component';
import { PaginationComponent } from './UI/mem-module/common/pagination/pagination.component';
import { VoiceCallLogComponent } from './UI/mem-module/common/voice-call-log/voice-call-log.component';
import { UploadDocumentComponent } from './UI/mem-module/lead-module/common/upload-document/upload-document.component';
import { DashboardCardComponent } from './UI/mem-module/common/home-module/common/dashboard-card/dashboard-card.component';
import { ContactCallIHComponent } from './UI/mem-module/common/contact-call/contact-call-IH/contact-call-ih.component';
import { ContactDetailComponent } from './UI/mem-module/contact-detail/contact-detail.component';
import { HomeSearchComponent } from './UI/mem-module/shared/home-search/home-search.component';
import { BuzzIndexComponent } from './UI/mem-module/shared/buzz-index/buzz-index.component';
import { SearchComponent } from './UI/mem-module/shared/search/search.component';
import { SearchContactService } from './services/contact-services/searchContact.service';
import { ContactSearchService } from './services/contact-services/shared/contact-search.service';
import { GridConfigurationService } from './services/contact-services/shared/gridConfiguration.service';
import { LinkGroupService } from './services/contact-services/link-group.service';
import { LiveConnectService } from './services/contact-services/live-connect.service';
import { TaskComponent } from './UI/mem-module/shared/task/task.component';
import { NullCheck } from './pipes/nullCheck.pipe';
import { CampaignEventListComponent } from './UI/mem-module/campaign-event-list/campaign-event-list.component';
import { CustomActionScreenComponent } from './UI/mem-module/custom-action-screen/custom-action-screen.component';
import { ActivityHistoryComponent } from './UI/mem-module/activity-history/activity-history.component';
import { safeurlpipe } from './UI/shared/htmlpipe/safehtmlpipe';

const maskConfig: Partial<IConfig> = {
    validation: false,
};

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        CounterComponent,
        FetchDataComponent,
        CmLocationsComponent,
        CmDashboardComponent,
        RptBcmDashboardComponent,
        CmGeneralComponent,
        CmPaymentComponent,
        LeftSideMenuComponent,
        LocationLeftMenuComponent,
        LmTriggersComponent,
        LmLinksComponent,
        LmGeneralComponent,
        LmProductsComponent,
        LmMarketingComponent,
        LmDiscountsComponent,
        LmEmployeesComponent,
        LmContractListComponent,
        LmContractSettingsComponent,
        LmEngageDashComponent,
        LmVesselsComponent,
        SiteFieldsComponent,
        CmEmployeesComponent,
        CmContractListComponent,
        CmContractComponent,
        CmContractClientComponent,
        CmContractMappingComponent,
        LmDashboardComponent,
        LmPaymentComponent,
        CmActivityLogComponent,
        CmContractLogComponent,
        CurrencyDirective,
        AcceptCharacterDirective,
        PercentageDirective,
        PhoneFormatPipe,
        MemDashboardComponent,
        MembershipComponent,
        MemContactComponent,
        MemContactDetailsComponent,
        MemPauseComponent,
        MemInsuranceDeductibleComponent,
        MemPolicyViolationComponent,
        MemCaseComponent,
        MemSubscriptionComponent,
        MemLeftSideMenuComponent,
        MemCaseListComponent,
        MembershipListComponent,
        MemInsuranceDeductibleListComponent,
        MemPolicyViolationListComponent,
        MemSubscriptionListComponent,
        MemPauseListComponent,
        MemContactListComponent,
        MembershipListComponent,
        MemInsuranceDeductibleListComponent,
        NullCheck,
        safehtmlpipe,
        


        BulkContactActionsComponent,
        ClassLookupComponent,
        ContactComponent,
        ContactActivityHistoryComponent,
        ContactListComponent,
        ContactUploadExcelComponent,
        ImportHistoryComponent,
        LeadApptComponent,
        QuickLinkComponent,
        LinkComponent,
        ManageCampaignsComponent,
        CampaignEventListComponent,
        ManageDuplicateComponent,
        AppointmentCommonComponent,
        BulkContactCommonComponent,
        ContactArchiveComponent,
        ContactCallComponent,
        ContactCommonSearchComponent,
        ContactDuplicateComponent,
        ContactEmailComponent,
        ContactExportsComponent,
        ContactHistoryNoteComponent,
        ContactMapCommonComponent,
        ContactMapComponent,
        ContactMeetingComponent,
        ContactNewCallComponent,
        ContactNoteComponent,
        ContactRecentLeadComponent,
        ContactRecentMailingComponent,
        ContactReferredComponent,
        ContactSearchComponent,
        ContactSettingsComponent,
        ContactSmsComponent,
        ContactTaskComponent,
        CustomActionScreenComponent,
        ActivityHistoryComponent,
        EmailOptLogComponent,
        QuickRecentListComponent,
        MobileOptLogComponent,
        MyCalenderComponent,
        PaginationComponent,
        VoiceCallLogComponent,
        UploadDocumentComponent,
        QuickRecentListComponent,
        DashboardCardComponent,
        ContactCallIHComponent,
        ContactDetailComponent,
        HomeSearchComponent,
        SearchComponent,
        TaskComponent,
        LeadEmailComponent,
        BuzzIndexComponent,
        EngageMetricComponent,
        safeurlpipe
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MenusModule,
        DropDownsModule,
        IconsModule,
        CommonModule,
        DropDownListModule,
        ChartsModule,
        ToastrModule.forRoot(),
        ButtonsModule,
        MatSelectModule,
        MatInputModule,
        MatPaginatorModule,
        ProgressBarModule,
        MatTableModule,
        MatSortModule,
        MatCheckboxModule,
        MatDialogModule,
        MatListModule,
        MatDatepickerModule,
        MatExpansionModule,
        MatCardModule,
        MatTabsModule,
        MatButtonModule,
        MatIconModule,
        MatChipsModule,
        MatStepperModule,
        MatFormFieldModule,
        DateInputsModule,
        MatGridListModule,
        MatRadioModule,
        CdkStepperModule,
        MatSnackBarModule,
        MatSidenavModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatNativeDateModule,
        EditorModule,
        CKEditorModule,
        DragDropModule,
        UploadsModule,
        CreditCardDirectivesModule,
        SignaturePadModule,
        NgxEditorModule,
        PowerBIEmbedModule,
        NgxMatDatetimePickerModule,
        NgxMatNativeDateModule,
        NgxMatTimepickerModule,
        NgxMaskModule.forRoot(maskConfig),
        RouterModule.forRoot([
            { path: '', redirectTo: 'unauthorized', pathMatch: 'full' },
            { path: 'fetch-data', component: FetchDataComponent },
            { path: 'cm-dashboard', component: CmDashboardComponent },
            { path: 'cm-locations', component: CmLocationsComponent },
            { path: 'site-fields', component: SiteFieldsComponent },
            { path: 'cm-general', component: CmGeneralComponent },
            { path: 'cm-payment', component: CmPaymentComponent },
            { path: 'cm-employees', component: CmEmployeesComponent },
            { path: 'cm-contracts', component: CmContractListComponent },
            { path: 'counter', component: CounterComponent },
            { path: 'sm-dashboard', component: LmDashboardComponent },
            { path: 'sm-general', component: LmGeneralComponent },
            { path: 'sm-products', component: LmProductsComponent },
            { path: 'sm-triggers', component: LmTriggersComponent },
            { path: 'sm-links', component: LmLinksComponent },
            { path: 'sm-marketing', component: LmMarketingComponent },
            { path: 'sm-discounts', component: LmDiscountsComponent },
            { path: 'sm-employees', component: LmEmployeesComponent },
            { path: 'sm-contracts', component: LmContractListComponent },
            { path: 'sm-contract-settings', component: LmContractSettingsComponent },
            { path: 'sm-engage-dash', component: LmEngageDashComponent },
            { path: 'sm-vessels', component: LmVesselsComponent },
            { path: 'sm-payment', component: LmPaymentComponent },
            { path: 'unauthorized', component: MissingCredentialsComponent },
            { path: 'cm-contract/:contactId', component: CmContractComponent },
            { path: 'cm-contract/:contactId/:userId', component: CmContractComponent },
            { path: 'cm-contract-client/:contactId/:userId/:contractId', component: CmContractClientComponent },
            { path: 'cm-contract-mapping', component: CmContractMappingComponent },
            { path: 'cm-contract-log/:contractId', component: CmContractLogComponent },
            { path: 'cm-activity-log/:contractId', component: CmActivityLogComponent },
            { path: 'mem-dashboard', component: MemDashboardComponent, title : 'Membership' },
            { path: 'mem-membership/:membershipIID', component: MembershipComponent, title: 'Membership'},
            { path: 'mem-contact/:contactID', component: MemContactDetailsComponent, title: 'Membership'},
            { path: 'mem-pause', component: MemPauseComponent, title: 'Membership'},
            { path: 'mem-insurance', component: MemInsuranceDeductibleComponent, title: 'Membership'},
            { path: 'mem-policy-violation', component: MemPolicyViolationComponent, title: 'Membership'},
            { path: 'mem-case', component: MemCaseComponent, title: 'Membership'},
            { path: 'mem-subscription', component: MemSubscriptionComponent, title: 'Membership'},
            { path: 'mem-membership-list', component: MembershipListComponent, title: 'Membership'},
            { path: 'mem-contact-list', component: MemContactListComponent, title: 'Membership'},
            { path: 'mem-pause-list', component: MemPauseListComponent, title: 'Membership'},
            { path: 'mem-insurance-list', component: MemInsuranceDeductibleListComponent, title: 'Membership'},
            { path: 'mem-case-list', component: MemCaseListComponent, title: 'Membership'},
            { path: 'mem-subscription-list', component: MemSubscriptionListComponent, title: 'Membership'},
            { path: 'mem-policy-violation-list', component: MemPolicyViolationListComponent, title: 'Membership'},
            { path: 'task/:ownerId/:cat', component: TaskComponent },
        ])
    ],
    providers: [DatePipe, EmailService, GlobalService, LocalService, LinkGroupService, LiveConnectService, GridConfigurationService, engagelocal, ContactSearchService, MenuService, SearchContactService, UtilityService, NotificationService, ToastrService, NullCheck],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class AppModule { }
